module.exports = __webpack_public_path__ + "static/media/notimg1.21d4ffd6.svg";